import type { I18nTranslate } from '@openx/types/translations.ts';
import { isAfter, isBefore, isToday } from 'date-fns';
import { object, string } from 'yup';
import { requestDirectDealFields } from './types.ts';

const DIGIT_WITH_DECIMAL_PLACES_REGEXP = /^(0|[1-9]\d*)(\.\d{1,2})?$/;

const isDateAfterToday = (date: string | null | undefined) => {
  if (!date) return true;
  return isAfter(new Date(date), new Date()) || isToday(new Date(date));
};

export const getValidationSchema = (t: I18nTranslate) =>
  object().shape({
    [requestDirectDealFields.DEAL_TYPE]: string().required(t('Deal Type is required.')),
    [requestDirectDealFields.ADVERTISER_BRAND]: string(),
    [requestDirectDealFields.BUDGET]: string().test(
      'is-valid-budget',
      t('Budget must be a valid number with up to 2 decimal places.'),
      value => {
        if (!value) return true;
        return DIGIT_WITH_DECIMAL_PLACES_REGEXP.test(value);
      }
    ),
    [requestDirectDealFields.START_DATE]: string()
      .nullable()
      .test('is-date-before-today', t('Start Date must be today or in the future.'), isDateAfterToday)
      .test('is-start-date-before-end-date', t('Start Date must be before End Date.'), function (startDate) {
        const endDate = this.parent[requestDirectDealFields.END_DATE];

        if (!startDate || !endDate) return true;
        return isBefore(new Date(startDate), new Date(endDate));
      }),
    [requestDirectDealFields.END_DATE]: string()
      .nullable()
      .test('is-date-before-today', t('End Date must be today or in the future.'), isDateAfterToday)
      .test('is-end-date-after-start-date', t('End Date must be after Start Date.'), function (endDate) {
        const startDate = this.parent[requestDirectDealFields.START_DATE];

        if (!startDate || !endDate) return true;
        return isBefore(new Date(startDate), new Date(endDate));
      }),
    [requestDirectDealFields.TARGETING_DETAILS]: string(),
  });
